export const generateUrl = (path: string, baseUrl: string) => new URL(path, baseUrl);
